import { render, staticRenderFns } from "./TabelaContratos.vue?vue&type=template&id=3b823e14&lang=pug"
import script from "./TabelaContratos.vue?vue&type=script&lang=js"
export * from "./TabelaContratos.vue?vue&type=script&lang=js"
import style0 from "./TabelaContratos.vue?vue&type=style&index=0&id=3b823e14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports